import { render } from "./integration-import-products.vue?vue&type=template&id=581f7202&scoped=true"
import script from "./integration-import-products.vue?vue&type=script&lang=js"
export * from "./integration-import-products.vue?vue&type=script&lang=js"

import "./integration-import-products.vue?vue&type=style&index=0&id=581f7202&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581f7202"]])

export default __exports__